import { useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export function useAnimatedDisclosure(duration = 300) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsMounted(true); // mount immediately
    } else {
      const timeout = setTimeout(() => setIsMounted(false), duration);
      return () => clearTimeout(timeout);
    }
  }, [isOpen, duration]);

  return { isOpen, onOpen, onClose, isMounted };
}